import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { CapacityFormData } from '../details/CapacityDashboardFilters';
import { CapacityFilter } from '@dispatch/shared/types';

const useUnassignedTasks = ({
  form,
  selectedFilter,
}: {
  form: UseFormReturn<CapacityFormData, any>;
  selectedFilter?: CapacityFilter;
}) => {
  const locationCriteria = form.watch('locationType');
  const formUnassignedTasks = form.watch('unassignedTasks');
  const [unassignedTasks, setUnassignedTasks] =
    React.useState(formUnassignedTasks);

  // remove unassigned tasks when location criteria changes
  React.useEffect(() => {
    if (selectedFilter === undefined) {
      form.setValue('unassignedTasks', []);
      form.setValue('states', []);
      form.setValue('counties', []);
      form.setValue('zipCodes', []);
    }
  }, [locationCriteria]);

  // conserve the values for the unassigned tasks count
  React.useEffect(() => {
    if (selectedFilter === undefined) {
      if (formUnassignedTasks.length !== unassignedTasks.length) {
        const currentTasksMap = new Map(
          unassignedTasks.map((task) => [task.location, task])
        );

        const newUnassignedTasks = formUnassignedTasks.map((task) => {
          const existingTask = currentTasksMap.get(task.location);
          if (existingTask) {
            form.setValue(
              `unassignedTasks.${formUnassignedTasks.indexOf(task)}.count`,
              existingTask.count
            );
            return { ...task, count: existingTask.count };
          }
          return task;
        });

        setUnassignedTasks(newUnassignedTasks);
      } else {
        setUnassignedTasks(formUnassignedTasks);
      }
    }
  }, [formUnassignedTasks, unassignedTasks, form]);
};

export default useUnassignedTasks;
